import "./ProductCardComponent.scss"
import "../Payment/PaymentB2CDetails.scss"
import TitleLogoComponent from "../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import { useNavigate } from "react-router-dom";
import { isAndroid, isIOS } from "react-device-detect";

const ProductCardPaymentComponent = (props) => {

    const {
        title, logoAltText, logoURL, 
        tagsArray, bannerAction, 
        cardClassName, isLoading, price,
        showProviderIcon, product
    } = props;

    let navigate = useNavigate();

    let obj= {
        type: product.productType,
        method: 'navigate-to-detail-page',
        obj: product
    }

    return (
        <>
            <div className={"ordered-course-info " + cardClassName }>
                <div className="d-flex order-tbox-sec">
                    <div className="brokarge-img">
                        {showProviderIcon ? (<TitleLogoComponent
                            logoURL={logoURL}
                            altText={logoAltText}
                            isLoading={isLoading}
                        />) : null}
                    </div>
                    <div className="order-info-course-sec">
                        <div className="order-course-title">
                            {isLoading ? (
                                <div className="card-logorow">
                                    <div>
                                        <ShimmerScreen case="rect" width="100%" height="1rem" />
                                    </div>
                                    <div className="mt-1">
                                        <ShimmerScreen case="rect" width="70%" height="1rem" />
                                    </div>
                                </div>
                            ) : (
                                <span
                                    className="card-logorow" style={{cursor:"pointer"}}
                                    onClick={()=> {  
                                        if ((isAndroid || isIOS) && product?.isMobile) {
                                        try {
                                            if (window.callbackHandler != undefined) {
                                                window.callbackHandler.postMessage(JSON.stringify(obj));
                                            }
                                            if (window.webkit != undefined) {
                                                if (window.webkit.messageHandlers.callbackHandler != undefined) {
                                                    window.webkit.messageHandlers.callbackHandler.postMessage(
                                                        JSON.stringify(obj)
                                                    );
                                                }
                                            }
                                        } catch (err) {
                                            console.log("error in sending message");
                                        }
                                    } else  {navigate(bannerAction)} 
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: title,
                                    }}
                                ></span>
                            )}
                        </div>
                        <div className="order-course-sub-title">
                            <TitleTagsComponent
                                tagsArray={tagsArray}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                </div>
                <div className="order-billed-price gap-2 justify-content-end">
                    {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                    >
                        <path
                            d="M10 3L4.5 8.5L2 6"
                            stroke="#D1D1D1"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg> */}
                    {price}
                </div>
            </div>
        </>
    )
}

export default ProductCardPaymentComponent